import http from "../axios-instance";

class MasterOrderService {
	async sendOrderToBoss(order_id) {
		return http
			.post(`/order/${order_id}/send_boss`, {})
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	async sendAgentOrderToBoss(order_id) {
		return http
			.post(`/agent_order/${order_id}/send_boss`, {})
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	getOrders() {
		return http
			.get("/master_order")
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	getOrder(order_id) {
		return http
			.get(`/master_order/${order_id}`)
			.then((res) => {
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	downloadNewFile(order) {
		return http
			.get(`/master_order/${order._id}/download_new_file`, {
				responseType: "blob",
			})
			.then((res) => {
				this.download(res.data, order.modified_file);
				return Promise.resolve(res.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	download(data, fileName) {
		let blob = new Blob([data], {
			type: "application/octet-stream",
		});
		let downloadElement = document.createElement("a");
		let href = window.URL.createObjectURL(blob);
		downloadElement.href = href;
		downloadElement.download = fileName.split(/__fn__(.+)/)[1];
		document.body.appendChild(downloadElement);
		downloadElement.click();
		document.body.removeChild(downloadElement);
		window.URL.revokeObjectURL(href);
	}
}

export default new MasterOrderService();
